import { FC, HTMLAttributes, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout } from 'antd';
import cn from 'classnames';

import { HeaderPublic } from 'widgets/Header';

import styles from '../LayoutAdvertiser/Layout.module.scss';

interface ILayoutPublicProps extends HTMLAttributes<HTMLDivElement> {
	outlet?: ReactNode;
}

export const LayoutPublic: FC<ILayoutPublicProps> = ({ className, outlet, ...props }) => {

	return (
		<Layout {...props} className={cn(className, styles.main)}>
				<HeaderPublic />
				<Layout.Content className={styles.content}>{outlet || <Outlet />}</Layout.Content>
		</Layout>
	);
};
